export default __webpack_public_path__ + "static/media/notify.009f4c07.svg";